export const employees = {
  main: "Employees",
};
